<h1>{{ 'MAIN_DASHBOARD.WS_DIRECTORY' | translate }}</h1>

<div class="content-container admin m-t-20">
  <div class="ui-g">
    <div class="ui-g-12">
      <p-tabView>
        <p-tabPanel [header]="'WS_DIRECTORY.COUNTRY.LINK_NAME' | translate">
          <wsd-country></wsd-country>
        </p-tabPanel>
        <p-tabPanel [header]="'WS_DIRECTORY.STANDARD_TITLE.LINK_NAME' | translate">
          <ng-template pTemplate="content">
            <wsd-standard-title></wsd-standard-title>
          </ng-template>
        </p-tabPanel>
        <p-tabPanel [header]="'WS_DIRECTORY.EXPERTISE_AREA.LINK_NAME' | translate">
          <ng-template pTemplate="content">
            <wsd-expertise-area></wsd-expertise-area>
          </ng-template>
        </p-tabPanel>
        <p-tabPanel [header]="'WS_DIRECTORY.ORGANIZATION_TYPE.LINK_NAME' | translate">
          <ng-template pTemplate="content">
            <wsd-organization-type></wsd-organization-type>
          </ng-template>
        </p-tabPanel>
        <p-tabPanel [header]="'WS_DIRECTORY.ORGANIZATION_SUBTYPE.LINK_NAME' | translate">
          <ng-template pTemplate="content">
            <wsd-organization-subtype></wsd-organization-subtype>
          </ng-template>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>

<p-confirmDialog appendTo="body" icon="fa fa-question-circle" [style]="{width: '425px'}"></p-confirmDialog>
